import { jsx as _jsx } from "react/jsx-runtime";
/* THIS IS A GENERATED FILE, DO NOT EDIT */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
// import utils
import { lazy } from "react";
const AddressBookIcon = lazy(() => import("./components/AddressBookIcon.atom"));
const AddressCardIcon = lazy(() => import("./components/AddressCardIcon.atom"));
const AlarmClockIcon = lazy(() => import("./components/AlarmClockIcon.atom"));
const AlienIcon = lazy(() => import("./components/AlienIcon.atom"));
const AlignCenterIcon = lazy(() => import("./components/AlignCenterIcon.atom"));
const AlignLeftIcon = lazy(() => import("./components/AlignLeftIcon.atom"));
const AlignRightIcon = lazy(() => import("./components/AlignRightIcon.atom"));
const AnglesLeftIcon = lazy(() => import("./components/AnglesLeftIcon.atom"));
const AnglesRightIcon = lazy(() => import("./components/AnglesRightIcon.atom"));
const ArchiveIcon = lazy(() => import("./components/ArchiveIcon.atom"));
const ArrowDownAZIcon = lazy(() => import("./components/ArrowDownAZIcon.atom"));
const ArrowDownArrowUpIcon = lazy(() => import("./components/ArrowDownArrowUpIcon.atom"));
const ArrowDownLeftAndArrowUpRightToCenterIcon = lazy(() => import("./components/ArrowDownLeftAndArrowUpRightToCenterIcon.atom"));
const ArrowDownIcon = lazy(() => import("./components/ArrowDownIcon.atom"));
const ArrowLeftToLineIcon = lazy(() => import("./components/ArrowLeftToLineIcon.atom"));
const ArrowLeftIcon = lazy(() => import("./components/ArrowLeftIcon.atom"));
const ArrowProgressIcon = lazy(() => import("./components/ArrowProgressIcon.atom"));
const ArrowRightArrowLeftIcon = lazy(() => import("./components/ArrowRightArrowLeftIcon.atom"));
const ArrowRightFromBracketIcon = lazy(() => import("./components/ArrowRightFromBracketIcon.atom"));
const ArrowRightToLineIcon = lazy(() => import("./components/ArrowRightToLineIcon.atom"));
const ArrowRightIcon = lazy(() => import("./components/ArrowRightIcon.atom"));
const ArrowRotateLeftIcon = lazy(() => import("./components/ArrowRotateLeftIcon.atom"));
const ArrowRotateRightIcon = lazy(() => import("./components/ArrowRotateRightIcon.atom"));
const ArrowTurnDownLeftIcon = lazy(() => import("./components/ArrowTurnDownLeftIcon.atom"));
const ArrowUpLongIcon = lazy(() => import("./components/ArrowUpLongIcon.atom"));
const ArrowUpRightAndArrowDownLeftFromCenterIcon = lazy(() => import("./components/ArrowUpRightAndArrowDownLeftFromCenterIcon.atom"));
const ArrowUpRightFromSquareIcon = lazy(() => import("./components/ArrowUpRightFromSquareIcon.atom"));
const ArrowUpIcon = lazy(() => import("./components/ArrowUpIcon.atom"));
const ArrowsRepeatIcon = lazy(() => import("./components/ArrowsRepeatIcon.atom"));
const ArrowsRotateIcon = lazy(() => import("./components/ArrowsRotateIcon.atom"));
const ArrowsSplitUpAndLeftIcon = lazy(() => import("./components/ArrowsSplitUpAndLeftIcon.atom"));
const AsteriskIcon = lazy(() => import("./components/AsteriskIcon.atom"));
const AtIcon = lazy(() => import("./components/AtIcon.atom"));
const BackwardStepIcon = lazy(() => import("./components/BackwardStepIcon.atom"));
const BackwardIcon = lazy(() => import("./components/BackwardIcon.atom"));
const BanIcon = lazy(() => import("./components/BanIcon.atom"));
const BarsChevronLeftIcon = lazy(() => import("./components/BarsChevronLeftIcon.atom"));
const BarsChevronRightIcon = lazy(() => import("./components/BarsChevronRightIcon.atom"));
const BarsSlashIcon = lazy(() => import("./components/BarsSlashIcon.atom"));
const BarsIcon = lazy(() => import("./components/BarsIcon.atom"));
const BasketShoppingIcon = lazy(() => import("./components/BasketShoppingIcon.atom"));
const BedIcon = lazy(() => import("./components/BedIcon.atom"));
const BellSlashIcon = lazy(() => import("./components/BellSlashIcon.atom"));
const BellIcon = lazy(() => import("./components/BellIcon.atom"));
const BicycleIcon = lazy(() => import("./components/BicycleIcon.atom"));
const BlockBrickIcon = lazy(() => import("./components/BlockBrickIcon.atom"));
const BoldIcon = lazy(() => import("./components/BoldIcon.atom"));
const BoltOutlineIcon = lazy(() => import("./components/BoltOutlineIcon.atom"));
const BookOpenIcon = lazy(() => import("./components/BookOpenIcon.atom"));
const BookUserIcon = lazy(() => import("./components/BookUserIcon.atom"));
const BookIcon = lazy(() => import("./components/BookIcon.atom"));
const BookmarkFillIcon = lazy(() => import("./components/BookmarkFillIcon.atom"));
const BookmarkOutlineIcon = lazy(() => import("./components/BookmarkOutlineIcon.atom"));
const BooksIcon = lazy(() => import("./components/BooksIcon.atom"));
const BoxOpenIcon = lazy(() => import("./components/BoxOpenIcon.atom"));
const BoxIcon = lazy(() => import("./components/BoxIcon.atom"));
const BoxingGloveIcon = lazy(() => import("./components/BoxingGloveIcon.atom"));
const BriefcaseIcon = lazy(() => import("./components/BriefcaseIcon.atom"));
const BroomIcon = lazy(() => import("./components/BroomIcon.atom"));
const BsnIcon = lazy(() => import("./components/BsnIcon.atom"));
const BuildingColumnsIcon = lazy(() => import("./components/BuildingColumnsIcon.atom"));
const BuildingIcon = lazy(() => import("./components/BuildingIcon.atom"));
const BullseyeArrowIcon = lazy(() => import("./components/BullseyeArrowIcon.atom"));
const CakeCandlesIcon = lazy(() => import("./components/CakeCandlesIcon.atom"));
const CalculatorIcon = lazy(() => import("./components/CalculatorIcon.atom"));
const CalendarCheckIcon = lazy(() => import("./components/CalendarCheckIcon.atom"));
const CalendarClockIcon = lazy(() => import("./components/CalendarClockIcon.atom"));
const CalendarDayIcon = lazy(() => import("./components/CalendarDayIcon.atom"));
const CalendarLinesPenIcon = lazy(() => import("./components/CalendarLinesPenIcon.atom"));
const CalendarMinusIcon = lazy(() => import("./components/CalendarMinusIcon.atom"));
const CalendarMonthIcon = lazy(() => import("./components/CalendarMonthIcon.atom"));
const CalendarPenIcon = lazy(() => import("./components/CalendarPenIcon.atom"));
const CalendarPlusIcon = lazy(() => import("./components/CalendarPlusIcon.atom"));
const CalendarStarIcon = lazy(() => import("./components/CalendarStarIcon.atom"));
const CalendarWeekIcon = lazy(() => import("./components/CalendarWeekIcon.atom"));
const CalendarXmarkIcon = lazy(() => import("./components/CalendarXmarkIcon.atom"));
const CalendarIcon = lazy(() => import("./components/CalendarIcon.atom"));
const CameraCctvIcon = lazy(() => import("./components/CameraCctvIcon.atom"));
const CameraRotateIcon = lazy(() => import("./components/CameraRotateIcon.atom"));
const CameraIcon = lazy(() => import("./components/CameraIcon.atom"));
const CarSideIcon = lazy(() => import("./components/CarSideIcon.atom"));
const CarIcon = lazy(() => import("./components/CarIcon.atom"));
const CaretDownIcon = lazy(() => import("./components/CaretDownIcon.atom"));
const CaretLeftIcon = lazy(() => import("./components/CaretLeftIcon.atom"));
const CaretRightIcon = lazy(() => import("./components/CaretRightIcon.atom"));
const CaretUpIcon = lazy(() => import("./components/CaretUpIcon.atom"));
const CartShoppingIcon = lazy(() => import("./components/CartShoppingIcon.atom"));
const ChartBarIcon = lazy(() => import("./components/ChartBarIcon.atom"));
const ChartLineHorizontalIcon = lazy(() => import("./components/ChartLineHorizontalIcon.atom"));
const ChartLineUpIcon = lazy(() => import("./components/ChartLineUpIcon.atom"));
const ChartLineIcon = lazy(() => import("./components/ChartLineIcon.atom"));
const ChartNetworkIcon = lazy(() => import("./components/ChartNetworkIcon.atom"));
const ChartPieIcon = lazy(() => import("./components/ChartPieIcon.atom"));
const CheckDoubleIcon = lazy(() => import("./components/CheckDoubleIcon.atom"));
const CheckToSlotIcon = lazy(() => import("./components/CheckToSlotIcon.atom"));
const CheckIcon = lazy(() => import("./components/CheckIcon.atom"));
const ChevronDownIcon = lazy(() => import("./components/ChevronDownIcon.atom"));
const ChevronLeftIcon = lazy(() => import("./components/ChevronLeftIcon.atom"));
const ChevronRightIcon = lazy(() => import("./components/ChevronRightIcon.atom"));
const ChevronUpIcon = lazy(() => import("./components/ChevronUpIcon.atom"));
const ChildrenIcon = lazy(() => import("./components/ChildrenIcon.atom"));
const CircleCheckIcon = lazy(() => import("./components/CircleCheckIcon.atom"));
const CircleExclamationIcon = lazy(() => import("./components/CircleExclamationIcon.atom"));
const CircleInfoIcon = lazy(() => import("./components/CircleInfoIcon.atom"));
const CircleMinusIcon = lazy(() => import("./components/CircleMinusIcon.atom"));
const CirclePlusIcon = lazy(() => import("./components/CirclePlusIcon.atom"));
const CircleSmallIcon = lazy(() => import("./components/CircleSmallIcon.atom"));
const CircleUserIcon = lazy(() => import("./components/CircleUserIcon.atom"));
const CircleXmarkIcon = lazy(() => import("./components/CircleXmarkIcon.atom"));
const CircleIcon = lazy(() => import("./components/CircleIcon.atom"));
const CirclesOverlapIcon = lazy(() => import("./components/CirclesOverlapIcon.atom"));
const ClipboardListCheckIcon = lazy(() => import("./components/ClipboardListCheckIcon.atom"));
const ClipboardListIcon = lazy(() => import("./components/ClipboardListIcon.atom"));
const ClockRotateLeftIcon = lazy(() => import("./components/ClockRotateLeftIcon.atom"));
const ClockIcon = lazy(() => import("./components/ClockIcon.atom"));
const CloneIcon = lazy(() => import("./components/CloneIcon.atom"));
const CloudArrowDownIcon = lazy(() => import("./components/CloudArrowDownIcon.atom"));
const CloudIcon = lazy(() => import("./components/CloudIcon.atom"));
const CodeIcon = lazy(() => import("./components/CodeIcon.atom"));
const CommentQuestionIcon = lazy(() => import("./components/CommentQuestionIcon.atom"));
const CommentIcon = lazy(() => import("./components/CommentIcon.atom"));
const CommentsIcon = lazy(() => import("./components/CommentsIcon.atom"));
const CompassIcon = lazy(() => import("./components/CompassIcon.atom"));
const CookieBiteIcon = lazy(() => import("./components/CookieBiteIcon.atom"));
const CopyIcon = lazy(() => import("./components/CopyIcon.atom"));
const CouchIcon = lazy(() => import("./components/CouchIcon.atom"));
const CovIcon = lazy(() => import("./components/CovIcon.atom"));
const CreditCardIcon = lazy(() => import("./components/CreditCardIcon.atom"));
const CrossIcon = lazy(() => import("./components/CrossIcon.atom"));
const CrownIcon = lazy(() => import("./components/CrownIcon.atom"));
const CrutchIcon = lazy(() => import("./components/CrutchIcon.atom"));
const CrutchesIcon = lazy(() => import("./components/CrutchesIcon.atom"));
const DecreaseTextsizeIcon = lazy(() => import("./components/DecreaseTextsizeIcon.atom"));
const DeleteLeftIcon = lazy(() => import("./components/DeleteLeftIcon.atom"));
const DesktopIcon = lazy(() => import("./components/DesktopIcon.atom"));
const DoorClosedIcon = lazy(() => import("./components/DoorClosedIcon.atom"));
const DoorOpenIcon = lazy(() => import("./components/DoorOpenIcon.atom"));
const DoveIcon = lazy(() => import("./components/DoveIcon.atom"));
const DownloadIcon = lazy(() => import("./components/DownloadIcon.atom"));
const EarDeafIcon = lazy(() => import("./components/EarDeafIcon.atom"));
const EarListenIcon = lazy(() => import("./components/EarListenIcon.atom"));
const EllipsisStrokeVerticalIcon = lazy(() => import("./components/EllipsisStrokeVerticalIcon.atom"));
const EllipsisStrokeIcon = lazy(() => import("./components/EllipsisStrokeIcon.atom"));
const EnvelopeOpenTextIcon = lazy(() => import("./components/EnvelopeOpenTextIcon.atom"));
const EnvelopeIcon = lazy(() => import("./components/EnvelopeIcon.atom"));
const EnvelopesBulkIcon = lazy(() => import("./components/EnvelopesBulkIcon.atom"));
const EqualsIcon = lazy(() => import("./components/EqualsIcon.atom"));
const EraserIcon = lazy(() => import("./components/EraserIcon.atom"));
const EuroSignIcon = lazy(() => import("./components/EuroSignIcon.atom"));
const EyeLowVisionIcon = lazy(() => import("./components/EyeLowVisionIcon.atom"));
const EyeSlashIcon = lazy(() => import("./components/EyeSlashIcon.atom"));
const EyeIcon = lazy(() => import("./components/EyeIcon.atom"));
const FaceFrownSlightIcon = lazy(() => import("./components/FaceFrownSlightIcon.atom"));
const FaceIdIcon = lazy(() => import("./components/FaceIdIcon.atom"));
const FaceMehIcon = lazy(() => import("./components/FaceMehIcon.atom"));
const FaceSmileIcon = lazy(() => import("./components/FaceSmileIcon.atom"));
const FamilyIcon = lazy(() => import("./components/FamilyIcon.atom"));
const FileAudioIcon = lazy(() => import("./components/FileAudioIcon.atom"));
const FileCertificateIcon = lazy(() => import("./components/FileCertificateIcon.atom"));
const FileCircleCheckIcon = lazy(() => import("./components/FileCircleCheckIcon.atom"));
const FileCircleExclamationIcon = lazy(() => import("./components/FileCircleExclamationIcon.atom"));
const FileCodeIcon = lazy(() => import("./components/FileCodeIcon.atom"));
const FileContractIcon = lazy(() => import("./components/FileContractIcon.atom"));
const FileCsvIcon = lazy(() => import("./components/FileCsvIcon.atom"));
const FileDocIcon = lazy(() => import("./components/FileDocIcon.atom"));
const FileGifIcon = lazy(() => import("./components/FileGifIcon.atom"));
const FileImageIcon = lazy(() => import("./components/FileImageIcon.atom"));
const FileJpgIcon = lazy(() => import("./components/FileJpgIcon.atom"));
const FileLinesIcon = lazy(() => import("./components/FileLinesIcon.atom"));
const FileLockIcon = lazy(() => import("./components/FileLockIcon.atom"));
const FileMagnifyingGlassIcon = lazy(() => import("./components/FileMagnifyingGlassIcon.atom"));
const FileMp3Icon = lazy(() => import("./components/FileMp3Icon.atom"));
const FileMp4Icon = lazy(() => import("./components/FileMp4Icon.atom"));
const FilePdfIcon = lazy(() => import("./components/FilePdfIcon.atom"));
const FilePngIcon = lazy(() => import("./components/FilePngIcon.atom"));
const FilePptIcon = lazy(() => import("./components/FilePptIcon.atom"));
const FileVideoIcon = lazy(() => import("./components/FileVideoIcon.atom"));
const FileWaveformIcon = lazy(() => import("./components/FileWaveformIcon.atom"));
const FileXlsIcon = lazy(() => import("./components/FileXlsIcon.atom"));
const FileZipIcon = lazy(() => import("./components/FileZipIcon.atom"));
const FileIcon = lazy(() => import("./components/FileIcon.atom"));
const FilesIcon = lazy(() => import("./components/FilesIcon.atom"));
const FilterCircleXmarkIcon = lazy(() => import("./components/FilterCircleXmarkIcon.atom"));
const FilterIcon = lazy(() => import("./components/FilterIcon.atom"));
const FlagCheckeredIcon = lazy(() => import("./components/FlagCheckeredIcon.atom"));
const FlagFillIcon = lazy(() => import("./components/FlagFillIcon.atom"));
const FlagOutlineIcon = lazy(() => import("./components/FlagOutlineIcon.atom"));
const FlaskIcon = lazy(() => import("./components/FlaskIcon.atom"));
const FlickrIcon = lazy(() => import("./components/FlickrIcon.atom"));
const FolderOpenIcon = lazy(() => import("./components/FolderOpenIcon.atom"));
const FolderPlusIcon = lazy(() => import("./components/FolderPlusIcon.atom"));
const FolderIcon = lazy(() => import("./components/FolderIcon.atom"));
const FontIcon = lazy(() => import("./components/FontIcon.atom"));
const ForwardStepIcon = lazy(() => import("./components/ForwardStepIcon.atom"));
const ForwardIcon = lazy(() => import("./components/ForwardIcon.atom"));
const FosterFamilyIcon = lazy(() => import("./components/FosterFamilyIcon.atom"));
const GaugeHighIcon = lazy(() => import("./components/GaugeHighIcon.atom"));
const GavelIcon = lazy(() => import("./components/GavelIcon.atom"));
const GearIcon = lazy(() => import("./components/GearIcon.atom"));
const GiftCardIcon = lazy(() => import("./components/GiftCardIcon.atom"));
const GiftIcon = lazy(() => import("./components/GiftIcon.atom"));
const GlobeIcon = lazy(() => import("./components/GlobeIcon.atom"));
const GoogleDriveIcon = lazy(() => import("./components/GoogleDriveIcon.atom"));
const GraduationCapIcon = lazy(() => import("./components/GraduationCapIcon.atom"));
const Grid2Icon = lazy(() => import("./components/Grid2Icon.atom"));
const GridListIcon = lazy(() => import("./components/GridListIcon.atom"));
const GridIcon = lazy(() => import("./components/GridIcon.atom"));
const GripDotsVerticalIcon = lazy(() => import("./components/GripDotsVerticalIcon.atom"));
const GroupInHandIcon = lazy(() => import("./components/GroupInHandIcon.atom"));
const HammerBrushIcon = lazy(() => import("./components/HammerBrushIcon.atom"));
const HammerIcon = lazy(() => import("./components/HammerIcon.atom"));
const HandBackPointUpIcon = lazy(() => import("./components/HandBackPointUpIcon.atom"));
const HandDotsIcon = lazy(() => import("./components/HandDotsIcon.atom"));
const HandFistIcon = lazy(() => import("./components/HandFistIcon.atom"));
const HandHoldingBoxIcon = lazy(() => import("./components/HandHoldingBoxIcon.atom"));
const HandHoldingMedicalIcon = lazy(() => import("./components/HandHoldingMedicalIcon.atom"));
const HandHoldingSeedlingIcon = lazy(() => import("./components/HandHoldingSeedlingIcon.atom"));
const HandWaveIcon = lazy(() => import("./components/HandWaveIcon.atom"));
const HandIcon = lazy(() => import("./components/HandIcon.atom"));
const HandcuffsIcon = lazy(() => import("./components/HandcuffsIcon.atom"));
const HandsHoldingCircleIcon = lazy(() => import("./components/HandsHoldingCircleIcon.atom"));
const HandsPrayingIcon = lazy(() => import("./components/HandsPrayingIcon.atom"));
const HandshakeIcon = lazy(() => import("./components/HandshakeIcon.atom"));
const HashtagIcon = lazy(() => import("./components/HashtagIcon.atom"));
const HeadSideBrainIcon = lazy(() => import("./components/HeadSideBrainIcon.atom"));
const HeadSideMedicalIcon = lazy(() => import("./components/HeadSideMedicalIcon.atom"));
const HeadSideSwallowIcon = lazy(() => import("./components/HeadSideSwallowIcon.atom"));
const HeadSideTalkingIcon = lazy(() => import("./components/HeadSideTalkingIcon.atom"));
const HeadSideIcon = lazy(() => import("./components/HeadSideIcon.atom"));
const HeadphonesSimpleIcon = lazy(() => import("./components/HeadphonesSimpleIcon.atom"));
const HeartFillIcon = lazy(() => import("./components/HeartFillIcon.atom"));
const HeartOutlineIcon = lazy(() => import("./components/HeartOutlineIcon.atom"));
const HeartPulseXmarkIcon = lazy(() => import("./components/HeartPulseXmarkIcon.atom"));
const HeartPulseIcon = lazy(() => import("./components/HeartPulseIcon.atom"));
const HighlightIcon = lazy(() => import("./components/HighlightIcon.atom"));
const HomeIcon = lazy(() => import("./components/HomeIcon.atom"));
const HospitalIcon = lazy(() => import("./components/HospitalIcon.atom"));
const HourglassHalfIcon = lazy(() => import("./components/HourglassHalfIcon.atom"));
const HouseBuildingIcon = lazy(() => import("./components/HouseBuildingIcon.atom"));
const HouseChimneyHeartIcon = lazy(() => import("./components/HouseChimneyHeartIcon.atom"));
const HouseChimneyMedicalIcon = lazy(() => import("./components/HouseChimneyMedicalIcon.atom"));
const HouseChimneyUserIcon = lazy(() => import("./components/HouseChimneyUserIcon.atom"));
const HouseChimneyIcon = lazy(() => import("./components/HouseChimneyIcon.atom"));
const HouseCircleCheckIcon = lazy(() => import("./components/HouseCircleCheckIcon.atom"));
const HouseCircleXmarkIcon = lazy(() => import("./components/HouseCircleXmarkIcon.atom"));
const HouseLockIcon = lazy(() => import("./components/HouseLockIcon.atom"));
const HouseMedicalIcon = lazy(() => import("./components/HouseMedicalIcon.atom"));
const HousePersonLeaveIcon = lazy(() => import("./components/HousePersonLeaveIcon.atom"));
const IconsIcon = lazy(() => import("./components/IconsIcon.atom"));
const IdCardIcon = lazy(() => import("./components/IdCardIcon.atom"));
const ImageIcon = lazy(() => import("./components/ImageIcon.atom"));
const InboxIcon = lazy(() => import("./components/InboxIcon.atom"));
const IncreaseTextsizeIcon = lazy(() => import("./components/IncreaseTextsizeIcon.atom"));
const IndentIcon = lazy(() => import("./components/IndentIcon.atom"));
const InfoIcon = lazy(() => import("./components/InfoIcon.atom"));
const ItalicIcon = lazy(() => import("./components/ItalicIcon.atom"));
const JoLogoIcon = lazy(() => import("./components/JoLogoIcon.atom"));
const KarifyArchiveSlashIcon = lazy(() => import("./components/KarifyArchiveSlashIcon.atom"));
const KarifyChevronDownSlashIcon = lazy(() => import("./components/KarifyChevronDownSlashIcon.atom"));
const KarifyFolderIcon = lazy(() => import("./components/KarifyFolderIcon.atom"));
const KarifyHealthspaceIcon = lazy(() => import("./components/KarifyHealthspaceIcon.atom"));
const KarifyHistoryIcon = lazy(() => import("./components/KarifyHistoryIcon.atom"));
const KarifyLockSlashIcon = lazy(() => import("./components/KarifyLockSlashIcon.atom"));
const KarifyLogoIcon = lazy(() => import("./components/KarifyLogoIcon.atom"));
const KarifyMinddistrictIcon = lazy(() => import("./components/KarifyMinddistrictIcon.atom"));
const KarifyPuzzleCheckIcon = lazy(() => import("./components/KarifyPuzzleCheckIcon.atom"));
const KarifyPuzzlePenIcon = lazy(() => import("./components/KarifyPuzzlePenIcon.atom"));
const KarifyRoquaIcon = lazy(() => import("./components/KarifyRoquaIcon.atom"));
const KarifyShieldFolderIcon = lazy(() => import("./components/KarifyShieldFolderIcon.atom"));
const KarifyShieldHistoryIcon = lazy(() => import("./components/KarifyShieldHistoryIcon.atom"));
const KarifyShieldIcon = lazy(() => import("./components/KarifyShieldIcon.atom"));
const KarifyShoppingBagIcon = lazy(() => import("./components/KarifyShoppingBagIcon.atom"));
const KarifyShoppingBasketIcon = lazy(() => import("./components/KarifyShoppingBasketIcon.atom"));
const KarifyWingIcon = lazy(() => import("./components/KarifyWingIcon.atom"));
const KeyIcon = lazy(() => import("./components/KeyIcon.atom"));
const KeyboardIcon = lazy(() => import("./components/KeyboardIcon.atom"));
const LayerGroupIcon = lazy(() => import("./components/LayerGroupIcon.atom"));
const LightEmergencyOnIcon = lazy(() => import("./components/LightEmergencyOnIcon.atom"));
const LightbulbOnIcon = lazy(() => import("./components/LightbulbOnIcon.atom"));
const LinkSimpleIcon = lazy(() => import("./components/LinkSimpleIcon.atom"));
const LinkSlashIcon = lazy(() => import("./components/LinkSlashIcon.atom"));
const LinkIcon = lazy(() => import("./components/LinkIcon.atom"));
const ListCheckIcon = lazy(() => import("./components/ListCheckIcon.atom"));
const ListOlIcon = lazy(() => import("./components/ListOlIcon.atom"));
const ListTreeIcon = lazy(() => import("./components/ListTreeIcon.atom"));
const ListUlIcon = lazy(() => import("./components/ListUlIcon.atom"));
const LocationCrosshairsIcon = lazy(() => import("./components/LocationCrosshairsIcon.atom"));
const LocationDotSlashIcon = lazy(() => import("./components/LocationDotSlashIcon.atom"));
const LocationDotIcon = lazy(() => import("./components/LocationDotIcon.atom"));
const LockOpenIcon = lazy(() => import("./components/LockOpenIcon.atom"));
const LockRegisterIcon = lazy(() => import("./components/LockRegisterIcon.atom"));
const LockUserIcon = lazy(() => import("./components/LockUserIcon.atom"));
const LockIcon = lazy(() => import("./components/LockIcon.atom"));
const LoggingIcon = lazy(() => import("./components/LoggingIcon.atom"));
const LungsIcon = lazy(() => import("./components/LungsIcon.atom"));
const MagnifyingGlassArrowsRotateIcon = lazy(() => import("./components/MagnifyingGlassArrowsRotateIcon.atom"));
const MagnifyingGlassMinusIcon = lazy(() => import("./components/MagnifyingGlassMinusIcon.atom"));
const MagnifyingGlassPlusIcon = lazy(() => import("./components/MagnifyingGlassPlusIcon.atom"));
const MagnifyingGlassIcon = lazy(() => import("./components/MagnifyingGlassIcon.atom"));
const MapLocationDotIcon = lazy(() => import("./components/MapLocationDotIcon.atom"));
const MarsIcon = lazy(() => import("./components/MarsIcon.atom"));
const MegaphoneIcon = lazy(() => import("./components/MegaphoneIcon.atom"));
const MessageArrowDownIcon = lazy(() => import("./components/MessageArrowDownIcon.atom"));
const MessageSmsIcon = lazy(() => import("./components/MessageSmsIcon.atom"));
const MessageIcon = lazy(() => import("./components/MessageIcon.atom"));
const MessagesIcon = lazy(() => import("./components/MessagesIcon.atom"));
const MicrophoneSlashIcon = lazy(() => import("./components/MicrophoneSlashIcon.atom"));
const MicrophoneIcon = lazy(() => import("./components/MicrophoneIcon.atom"));
const MicrosoftOnedriveIcon = lazy(() => import("./components/MicrosoftOnedriveIcon.atom"));
const MinusIcon = lazy(() => import("./components/MinusIcon.atom"));
const MobileIcon = lazy(() => import("./components/MobileIcon.atom"));
const MoneyBillWaveIcon = lazy(() => import("./components/MoneyBillWaveIcon.atom"));
const MoneyCheckPenIcon = lazy(() => import("./components/MoneyCheckPenIcon.atom"));
const MoonCloudIcon = lazy(() => import("./components/MoonCloudIcon.atom"));
const MoonIcon = lazy(() => import("./components/MoonIcon.atom"));
const MugHotIcon = lazy(() => import("./components/MugHotIcon.atom"));
const MugSaucerIcon = lazy(() => import("./components/MugSaucerIcon.atom"));
const NetherlandsIcon = lazy(() => import("./components/NetherlandsIcon.atom"));
const NewspaperIcon = lazy(() => import("./components/NewspaperIcon.atom"));
const NoteIcon = lazy(() => import("./components/NoteIcon.atom"));
const ObjectsColumnIcon = lazy(() => import("./components/ObjectsColumnIcon.atom"));
const OutdentIcon = lazy(() => import("./components/OutdentIcon.atom"));
const PaletteIcon = lazy(() => import("./components/PaletteIcon.atom"));
const PaperPlaneIcon = lazy(() => import("./components/PaperPlaneIcon.atom"));
const PaperclipIcon = lazy(() => import("./components/PaperclipIcon.atom"));
const PasteFromWordIcon = lazy(() => import("./components/PasteFromWordIcon.atom"));
const PasteTextIcon = lazy(() => import("./components/PasteTextIcon.atom"));
const PasteIcon = lazy(() => import("./components/PasteIcon.atom"));
const PauseIcon = lazy(() => import("./components/PauseIcon.atom"));
const PenToSquareIcon = lazy(() => import("./components/PenToSquareIcon.atom"));
const PenIcon = lazy(() => import("./components/PenIcon.atom"));
const PeopleArrowsIcon = lazy(() => import("./components/PeopleArrowsIcon.atom"));
const PeopleCarryBoxIcon = lazy(() => import("./components/PeopleCarryBoxIcon.atom"));
const PeopleGroupIcon = lazy(() => import("./components/PeopleGroupIcon.atom"));
const PeopleLineIcon = lazy(() => import("./components/PeopleLineIcon.atom"));
const PersonChalkboardIcon = lazy(() => import("./components/PersonChalkboardIcon.atom"));
const PersonDiggingIcon = lazy(() => import("./components/PersonDiggingIcon.atom"));
const PersonFallingBurstIcon = lazy(() => import("./components/PersonFallingBurstIcon.atom"));
const PersonFallingIcon = lazy(() => import("./components/PersonFallingIcon.atom"));
const PersonHelpingIcon = lazy(() => import("./components/PersonHelpingIcon.atom"));
const PersonInHandIcon = lazy(() => import("./components/PersonInHandIcon.atom"));
const PersonStarIcon = lazy(() => import("./components/PersonStarIcon.atom"));
const PersonStarsIcon = lazy(() => import("./components/PersonStarsIcon.atom"));
const PersonWalkingWithCaneIcon = lazy(() => import("./components/PersonWalkingWithCaneIcon.atom"));
const PersonIcon = lazy(() => import("./components/PersonIcon.atom"));
const PhoneHangupIcon = lazy(() => import("./components/PhoneHangupIcon.atom"));
const PhoneMissedIcon = lazy(() => import("./components/PhoneMissedIcon.atom"));
const PhonePlusIcon = lazy(() => import("./components/PhonePlusIcon.atom"));
const PhoneIcon = lazy(() => import("./components/PhoneIcon.atom"));
const PhotoFilmIcon = lazy(() => import("./components/PhotoFilmIcon.atom"));
const PillsIcon = lazy(() => import("./components/PillsIcon.atom"));
const PlateUtensilsIcon = lazy(() => import("./components/PlateUtensilsIcon.atom"));
const PlayIcon = lazy(() => import("./components/PlayIcon.atom"));
const PlugIcon = lazy(() => import("./components/PlugIcon.atom"));
const PlusIcon = lazy(() => import("./components/PlusIcon.atom"));
const PrescriptionBottleMedicalIcon = lazy(() => import("./components/PrescriptionBottleMedicalIcon.atom"));
const PresentationScreenIcon = lazy(() => import("./components/PresentationScreenIcon.atom"));
const PrintIcon = lazy(() => import("./components/PrintIcon.atom"));
const PuzzlePieceSimpleIcon = lazy(() => import("./components/PuzzlePieceSimpleIcon.atom"));
const QrcodeIcon = lazy(() => import("./components/QrcodeIcon.atom"));
const QuestionIcon = lazy(() => import("./components/QuestionIcon.atom"));
const QuoteRightIcon = lazy(() => import("./components/QuoteRightIcon.atom"));
const ReceiptIcon = lazy(() => import("./components/ReceiptIcon.atom"));
const ReplyIcon = lazy(() => import("./components/ReplyIcon.atom"));
const RightLeftIcon = lazy(() => import("./components/RightLeftIcon.atom"));
const RingsWeddingIcon = lazy(() => import("./components/RingsWeddingIcon.atom"));
const RoadIcon = lazy(() => import("./components/RoadIcon.atom"));
const RocketLaunchIcon = lazy(() => import("./components/RocketLaunchIcon.atom"));
const RoomIcon = lazy(() => import("./components/RoomIcon.atom"));
const RotateExclamationIcon = lazy(() => import("./components/RotateExclamationIcon.atom"));
const RouteIcon = lazy(() => import("./components/RouteIcon.atom"));
const RulerIcon = lazy(() => import("./components/RulerIcon.atom"));
const ScaleBalancedIcon = lazy(() => import("./components/ScaleBalancedIcon.atom"));
const ScissorsIcon = lazy(() => import("./components/ScissorsIcon.atom"));
const ScrollIcon = lazy(() => import("./components/ScrollIcon.atom"));
const SdbLogoIcon = lazy(() => import("./components/SdbLogoIcon.atom"));
const ShareNodesIcon = lazy(() => import("./components/ShareNodesIcon.atom"));
const ShareIcon = lazy(() => import("./components/ShareIcon.atom"));
const ShieldCheckIcon = lazy(() => import("./components/ShieldCheckIcon.atom"));
const ShieldHistoryIcon = lazy(() => import("./components/ShieldHistoryIcon.atom"));
const ShieldKeyholeIcon = lazy(() => import("./components/ShieldKeyholeIcon.atom"));
const ShieldPlusIcon = lazy(() => import("./components/ShieldPlusIcon.atom"));
const ShowerIcon = lazy(() => import("./components/ShowerIcon.atom"));
const ShuffleIcon = lazy(() => import("./components/ShuffleIcon.atom"));
const SignatureIcon = lazy(() => import("./components/SignatureIcon.atom"));
const SignpostIcon = lazy(() => import("./components/SignpostIcon.atom"));
const SitemapIcon = lazy(() => import("./components/SitemapIcon.atom"));
const SkypeIcon = lazy(() => import("./components/SkypeIcon.atom"));
const SlidersIcon = lazy(() => import("./components/SlidersIcon.atom"));
const SortIcon = lazy(() => import("./components/SortIcon.atom"));
const SpinnerScaleIcon = lazy(() => import("./components/SpinnerScaleIcon.atom"));
const SquareCheckIcon = lazy(() => import("./components/SquareCheckIcon.atom"));
const SquareFacebookIcon = lazy(() => import("./components/SquareFacebookIcon.atom"));
const SquareParkingIcon = lazy(() => import("./components/SquareParkingIcon.atom"));
const StampIcon = lazy(() => import("./components/StampIcon.atom"));
const StarFillIcon = lazy(() => import("./components/StarFillIcon.atom"));
const StarOutlineIcon = lazy(() => import("./components/StarOutlineIcon.atom"));
const StethoscopeIcon = lazy(() => import("./components/StethoscopeIcon.atom"));
const StopIcon = lazy(() => import("./components/StopIcon.atom"));
const StopwatchIcon = lazy(() => import("./components/StopwatchIcon.atom"));
const StrikethroughIcon = lazy(() => import("./components/StrikethroughIcon.atom"));
const SuitcaseMedicalIcon = lazy(() => import("./components/SuitcaseMedicalIcon.atom"));
const SunBrightIcon = lazy(() => import("./components/SunBrightIcon.atom"));
const SunglassesIcon = lazy(() => import("./components/SunglassesIcon.atom"));
const SyringeIcon = lazy(() => import("./components/SyringeIcon.atom"));
const TableCellsIcon = lazy(() => import("./components/TableCellsIcon.atom"));
const TableColumnsIcon = lazy(() => import("./components/TableColumnsIcon.atom"));
const TableIcon = lazy(() => import("./components/TableIcon.atom"));
const TagIcon = lazy(() => import("./components/TagIcon.atom"));
const TaxiBusIcon = lazy(() => import("./components/TaxiBusIcon.atom"));
const TemperatureThreeQuartersIcon = lazy(() => import("./components/TemperatureThreeQuartersIcon.atom"));
const TextIcon = lazy(() => import("./components/TextIcon.atom"));
const ThoughtBubbleIcon = lazy(() => import("./components/ThoughtBubbleIcon.atom"));
const ThumbsDownFillIcon = lazy(() => import("./components/ThumbsDownFillIcon.atom"));
const ThumbsDownOutlineIcon = lazy(() => import("./components/ThumbsDownOutlineIcon.atom"));
const ThumbsUpFillIcon = lazy(() => import("./components/ThumbsUpFillIcon.atom"));
const ThumbsUpOutlineIcon = lazy(() => import("./components/ThumbsUpOutlineIcon.atom"));
const ThumbtackFillIcon = lazy(() => import("./components/ThumbtackFillIcon.atom"));
const ThumbtackIcon = lazy(() => import("./components/ThumbtackIcon.atom"));
const TimelineArrowIcon = lazy(() => import("./components/TimelineArrowIcon.atom"));
const TombstoneIcon = lazy(() => import("./components/TombstoneIcon.atom"));
const ToothIcon = lazy(() => import("./components/ToothIcon.atom"));
const ToothbrushIcon = lazy(() => import("./components/ToothbrushIcon.atom"));
const TouchIdIcon = lazy(() => import("./components/TouchIdIcon.atom"));
const TrainTramIcon = lazy(() => import("./components/TrainTramIcon.atom"));
const TrashCanIcon = lazy(() => import("./components/TrashCanIcon.atom"));
const TreeCityIcon = lazy(() => import("./components/TreeCityIcon.atom"));
const TreePalmIcon = lazy(() => import("./components/TreePalmIcon.atom"));
const TriangleExclamationIcon = lazy(() => import("./components/TriangleExclamationIcon.atom"));
const TrophyIcon = lazy(() => import("./components/TrophyIcon.atom"));
const TruckMedicalIcon = lazy(() => import("./components/TruckMedicalIcon.atom"));
const UmbrellaBeachIcon = lazy(() => import("./components/UmbrellaBeachIcon.atom"));
const UmbrellaIcon = lazy(() => import("./components/UmbrellaIcon.atom"));
const UnderlineIcon = lazy(() => import("./components/UnderlineIcon.atom"));
const UniversalAccessDashedIcon = lazy(() => import("./components/UniversalAccessDashedIcon.atom"));
const UnlockRegisterIcon = lazy(() => import("./components/UnlockRegisterIcon.atom"));
const UnlockUserIcon = lazy(() => import("./components/UnlockUserIcon.atom"));
const UploadIcon = lazy(() => import("./components/UploadIcon.atom"));
const UserCheckIcon = lazy(() => import("./components/UserCheckIcon.atom"));
const UserClockIcon = lazy(() => import("./components/UserClockIcon.atom"));
const UserCrownIcon = lazy(() => import("./components/UserCrownIcon.atom"));
const UserDoctorIcon = lazy(() => import("./components/UserDoctorIcon.atom"));
const UserGroupIcon = lazy(() => import("./components/UserGroupIcon.atom"));
const UserHairIcon = lazy(() => import("./components/UserHairIcon.atom"));
const UserInviteIcon = lazy(() => import("./components/UserInviteIcon.atom"));
const UserLockIcon = lazy(() => import("./components/UserLockIcon.atom"));
const UserMagnifyingGlassIcon = lazy(() => import("./components/UserMagnifyingGlassIcon.atom"));
const UserMinusIcon = lazy(() => import("./components/UserMinusIcon.atom"));
const UserPenIcon = lazy(() => import("./components/UserPenIcon.atom"));
const UserPlusIcon = lazy(() => import("./components/UserPlusIcon.atom"));
const UserSlashIcon = lazy(() => import("./components/UserSlashIcon.atom"));
const UserXmarkIcon = lazy(() => import("./components/UserXmarkIcon.atom"));
const UserIcon = lazy(() => import("./components/UserIcon.atom"));
const UsersMedicalIcon = lazy(() => import("./components/UsersMedicalIcon.atom"));
const UsersIcon = lazy(() => import("./components/UsersIcon.atom"));
const VacuumIcon = lazy(() => import("./components/VacuumIcon.atom"));
const VenusMarsIcon = lazy(() => import("./components/VenusMarsIcon.atom"));
const VenusIcon = lazy(() => import("./components/VenusIcon.atom"));
const VideoPlusIcon = lazy(() => import("./components/VideoPlusIcon.atom"));
const VideoSlashIcon = lazy(() => import("./components/VideoSlashIcon.atom"));
const VideoIcon = lazy(() => import("./components/VideoIcon.atom"));
const VolumeXmarkIcon = lazy(() => import("./components/VolumeXmarkIcon.atom"));
const VolumeIcon = lazy(() => import("./components/VolumeIcon.atom"));
const WandMagicSparklesIcon = lazy(() => import("./components/WandMagicSparklesIcon.atom"));
const WhatsappIcon = lazy(() => import("./components/WhatsappIcon.atom"));
const WheatIcon = lazy(() => import("./components/WheatIcon.atom"));
const WheelchairIcon = lazy(() => import("./components/WheelchairIcon.atom"));
const WidIcon = lazy(() => import("./components/WidIcon.atom"));
const XmarkIcon = lazy(() => import("./components/XmarkIcon.atom"));
export const IconAtomComponent = ({ type, ...props }) => {
    switch (type) {
        case "address-book":
            return _jsx(AddressBookIcon, { ...props });
        case "address-card":
            return _jsx(AddressCardIcon, { ...props });
        case "alarm-clock":
            return _jsx(AlarmClockIcon, { ...props });
        case "alien":
            return _jsx(AlienIcon, { ...props });
        case "align-center":
            return _jsx(AlignCenterIcon, { ...props });
        case "align-left":
            return _jsx(AlignLeftIcon, { ...props });
        case "align-right":
            return _jsx(AlignRightIcon, { ...props });
        case "angles-left":
            return _jsx(AnglesLeftIcon, { ...props });
        case "angles-right":
            return _jsx(AnglesRightIcon, { ...props });
        case "archive":
            return _jsx(ArchiveIcon, { ...props });
        case "arrow-down-a-z":
            return _jsx(ArrowDownAZIcon, { ...props });
        case "arrow-down-arrow-up":
            return _jsx(ArrowDownArrowUpIcon, { ...props });
        case "arrow-down-left-and-arrow-up-right-to-center":
            return _jsx(ArrowDownLeftAndArrowUpRightToCenterIcon, { ...props });
        case "arrow-down":
            return _jsx(ArrowDownIcon, { ...props });
        case "arrow-left-to-line":
            return _jsx(ArrowLeftToLineIcon, { ...props });
        case "arrow-left":
            return _jsx(ArrowLeftIcon, { ...props });
        case "arrow-progress":
            return _jsx(ArrowProgressIcon, { ...props });
        case "arrow-right-arrow-left":
            return _jsx(ArrowRightArrowLeftIcon, { ...props });
        case "arrow-right-from-bracket":
            return _jsx(ArrowRightFromBracketIcon, { ...props });
        case "arrow-right-to-line":
            return _jsx(ArrowRightToLineIcon, { ...props });
        case "arrow-right":
            return _jsx(ArrowRightIcon, { ...props });
        case "arrow-rotate-left":
            return _jsx(ArrowRotateLeftIcon, { ...props });
        case "arrow-rotate-right":
            return _jsx(ArrowRotateRightIcon, { ...props });
        case "arrow-turn-down-left":
            return _jsx(ArrowTurnDownLeftIcon, { ...props });
        case "arrow-up-long":
            return _jsx(ArrowUpLongIcon, { ...props });
        case "arrow-up-right-and-arrow-down-left-from-center":
            return _jsx(ArrowUpRightAndArrowDownLeftFromCenterIcon, { ...props });
        case "arrow-up-right-from-square":
            return _jsx(ArrowUpRightFromSquareIcon, { ...props });
        case "arrow-up":
            return _jsx(ArrowUpIcon, { ...props });
        case "arrows-repeat":
            return _jsx(ArrowsRepeatIcon, { ...props });
        case "arrows-rotate":
            return _jsx(ArrowsRotateIcon, { ...props });
        case "arrows-split-up-and-left":
            return _jsx(ArrowsSplitUpAndLeftIcon, { ...props });
        case "asterisk":
            return _jsx(AsteriskIcon, { ...props });
        case "at":
            return _jsx(AtIcon, { ...props });
        case "backward-step":
            return _jsx(BackwardStepIcon, { ...props });
        case "backward":
            return _jsx(BackwardIcon, { ...props });
        case "ban":
            return _jsx(BanIcon, { ...props });
        case "bars-chevron-left":
            return _jsx(BarsChevronLeftIcon, { ...props });
        case "bars-chevron-right":
            return _jsx(BarsChevronRightIcon, { ...props });
        case "bars-slash":
            return _jsx(BarsSlashIcon, { ...props });
        case "bars":
            return _jsx(BarsIcon, { ...props });
        case "basket-shopping":
            return _jsx(BasketShoppingIcon, { ...props });
        case "bed":
            return _jsx(BedIcon, { ...props });
        case "bell-slash":
            return _jsx(BellSlashIcon, { ...props });
        case "bell":
            return _jsx(BellIcon, { ...props });
        case "bicycle":
            return _jsx(BicycleIcon, { ...props });
        case "block-brick":
            return _jsx(BlockBrickIcon, { ...props });
        case "bold":
            return _jsx(BoldIcon, { ...props });
        case "bolt-outline":
            return _jsx(BoltOutlineIcon, { ...props });
        case "book-open":
            return _jsx(BookOpenIcon, { ...props });
        case "book-user":
            return _jsx(BookUserIcon, { ...props });
        case "book":
            return _jsx(BookIcon, { ...props });
        case "bookmark-fill":
            return _jsx(BookmarkFillIcon, { ...props });
        case "bookmark-outline":
            return _jsx(BookmarkOutlineIcon, { ...props });
        case "books":
            return _jsx(BooksIcon, { ...props });
        case "box-open":
            return _jsx(BoxOpenIcon, { ...props });
        case "box":
            return _jsx(BoxIcon, { ...props });
        case "boxing-glove":
            return _jsx(BoxingGloveIcon, { ...props });
        case "briefcase":
            return _jsx(BriefcaseIcon, { ...props });
        case "broom":
            return _jsx(BroomIcon, { ...props });
        case "bsn":
            return _jsx(BsnIcon, { ...props });
        case "building-columns":
            return _jsx(BuildingColumnsIcon, { ...props });
        case "building":
            return _jsx(BuildingIcon, { ...props });
        case "bullseye-arrow":
            return _jsx(BullseyeArrowIcon, { ...props });
        case "cake-candles":
            return _jsx(CakeCandlesIcon, { ...props });
        case "calculator":
            return _jsx(CalculatorIcon, { ...props });
        case "calendar-check":
            return _jsx(CalendarCheckIcon, { ...props });
        case "calendar-clock":
            return _jsx(CalendarClockIcon, { ...props });
        case "calendar-day":
            return _jsx(CalendarDayIcon, { ...props });
        case "calendar-lines-pen":
            return _jsx(CalendarLinesPenIcon, { ...props });
        case "calendar-minus":
            return _jsx(CalendarMinusIcon, { ...props });
        case "calendar-month":
            return _jsx(CalendarMonthIcon, { ...props });
        case "calendar-pen":
            return _jsx(CalendarPenIcon, { ...props });
        case "calendar-plus":
            return _jsx(CalendarPlusIcon, { ...props });
        case "calendar-star":
            return _jsx(CalendarStarIcon, { ...props });
        case "calendar-week":
            return _jsx(CalendarWeekIcon, { ...props });
        case "calendar-xmark":
            return _jsx(CalendarXmarkIcon, { ...props });
        case "calendar":
            return _jsx(CalendarIcon, { ...props });
        case "camera-cctv":
            return _jsx(CameraCctvIcon, { ...props });
        case "camera-rotate":
            return _jsx(CameraRotateIcon, { ...props });
        case "camera":
            return _jsx(CameraIcon, { ...props });
        case "car-side":
            return _jsx(CarSideIcon, { ...props });
        case "car":
            return _jsx(CarIcon, { ...props });
        case "caret-down":
            return _jsx(CaretDownIcon, { ...props });
        case "caret-left":
            return _jsx(CaretLeftIcon, { ...props });
        case "caret-right":
            return _jsx(CaretRightIcon, { ...props });
        case "caret-up":
            return _jsx(CaretUpIcon, { ...props });
        case "cart-shopping":
            return _jsx(CartShoppingIcon, { ...props });
        case "chart-bar":
            return _jsx(ChartBarIcon, { ...props });
        case "chart-line-horizontal":
            return _jsx(ChartLineHorizontalIcon, { ...props });
        case "chart-line-up":
            return _jsx(ChartLineUpIcon, { ...props });
        case "chart-line":
            return _jsx(ChartLineIcon, { ...props });
        case "chart-network":
            return _jsx(ChartNetworkIcon, { ...props });
        case "chart-pie":
            return _jsx(ChartPieIcon, { ...props });
        case "check-double":
            return _jsx(CheckDoubleIcon, { ...props });
        case "check-to-slot":
            return _jsx(CheckToSlotIcon, { ...props });
        case "check":
            return _jsx(CheckIcon, { ...props });
        case "chevron-down":
            return _jsx(ChevronDownIcon, { ...props });
        case "chevron-left":
            return _jsx(ChevronLeftIcon, { ...props });
        case "chevron-right":
            return _jsx(ChevronRightIcon, { ...props });
        case "chevron-up":
            return _jsx(ChevronUpIcon, { ...props });
        case "children":
            return _jsx(ChildrenIcon, { ...props });
        case "circle-check":
            return _jsx(CircleCheckIcon, { ...props });
        case "circle-exclamation":
            return _jsx(CircleExclamationIcon, { ...props });
        case "circle-info":
            return _jsx(CircleInfoIcon, { ...props });
        case "circle-minus":
            return _jsx(CircleMinusIcon, { ...props });
        case "circle-plus":
            return _jsx(CirclePlusIcon, { ...props });
        case "circle-small":
            return _jsx(CircleSmallIcon, { ...props });
        case "circle-user":
            return _jsx(CircleUserIcon, { ...props });
        case "circle-xmark":
            return _jsx(CircleXmarkIcon, { ...props });
        case "circle":
            return _jsx(CircleIcon, { ...props });
        case "circles-overlap":
            return _jsx(CirclesOverlapIcon, { ...props });
        case "clipboard-list-check":
            return _jsx(ClipboardListCheckIcon, { ...props });
        case "clipboard-list":
            return _jsx(ClipboardListIcon, { ...props });
        case "clock-rotate-left":
            return _jsx(ClockRotateLeftIcon, { ...props });
        case "clock":
            return _jsx(ClockIcon, { ...props });
        case "clone":
            return _jsx(CloneIcon, { ...props });
        case "cloud-arrow-down":
            return _jsx(CloudArrowDownIcon, { ...props });
        case "cloud":
            return _jsx(CloudIcon, { ...props });
        case "code":
            return _jsx(CodeIcon, { ...props });
        case "comment-question":
            return _jsx(CommentQuestionIcon, { ...props });
        case "comment":
            return _jsx(CommentIcon, { ...props });
        case "comments":
            return _jsx(CommentsIcon, { ...props });
        case "compass":
            return _jsx(CompassIcon, { ...props });
        case "cookie-bite":
            return _jsx(CookieBiteIcon, { ...props });
        case "copy":
            return _jsx(CopyIcon, { ...props });
        case "couch":
            return _jsx(CouchIcon, { ...props });
        case "cov":
            return _jsx(CovIcon, { ...props });
        case "credit-card":
            return _jsx(CreditCardIcon, { ...props });
        case "cross":
            return _jsx(CrossIcon, { ...props });
        case "crown":
            return _jsx(CrownIcon, { ...props });
        case "crutch":
            return _jsx(CrutchIcon, { ...props });
        case "crutches":
            return _jsx(CrutchesIcon, { ...props });
        case "decrease-textsize":
            return _jsx(DecreaseTextsizeIcon, { ...props });
        case "delete-left":
            return _jsx(DeleteLeftIcon, { ...props });
        case "desktop":
            return _jsx(DesktopIcon, { ...props });
        case "door-closed":
            return _jsx(DoorClosedIcon, { ...props });
        case "door-open":
            return _jsx(DoorOpenIcon, { ...props });
        case "dove":
            return _jsx(DoveIcon, { ...props });
        case "download":
            return _jsx(DownloadIcon, { ...props });
        case "ear-deaf":
            return _jsx(EarDeafIcon, { ...props });
        case "ear-listen":
            return _jsx(EarListenIcon, { ...props });
        case "ellipsis-stroke-vertical":
            return _jsx(EllipsisStrokeVerticalIcon, { ...props });
        case "ellipsis-stroke":
            return _jsx(EllipsisStrokeIcon, { ...props });
        case "envelope-open-text":
            return _jsx(EnvelopeOpenTextIcon, { ...props });
        case "envelope":
            return _jsx(EnvelopeIcon, { ...props });
        case "envelopes-bulk":
            return _jsx(EnvelopesBulkIcon, { ...props });
        case "equals":
            return _jsx(EqualsIcon, { ...props });
        case "eraser":
            return _jsx(EraserIcon, { ...props });
        case "euro-sign":
            return _jsx(EuroSignIcon, { ...props });
        case "eye-low-vision":
            return _jsx(EyeLowVisionIcon, { ...props });
        case "eye-slash":
            return _jsx(EyeSlashIcon, { ...props });
        case "eye":
            return _jsx(EyeIcon, { ...props });
        case "face-frown-slight":
            return _jsx(FaceFrownSlightIcon, { ...props });
        case "face-id":
            return _jsx(FaceIdIcon, { ...props });
        case "face-meh":
            return _jsx(FaceMehIcon, { ...props });
        case "face-smile":
            return _jsx(FaceSmileIcon, { ...props });
        case "family":
            return _jsx(FamilyIcon, { ...props });
        case "file-audio":
            return _jsx(FileAudioIcon, { ...props });
        case "file-certificate":
            return _jsx(FileCertificateIcon, { ...props });
        case "file-circle-check":
            return _jsx(FileCircleCheckIcon, { ...props });
        case "file-circle-exclamation":
            return _jsx(FileCircleExclamationIcon, { ...props });
        case "file-code":
            return _jsx(FileCodeIcon, { ...props });
        case "file-contract":
            return _jsx(FileContractIcon, { ...props });
        case "file-csv":
            return _jsx(FileCsvIcon, { ...props });
        case "file-doc":
            return _jsx(FileDocIcon, { ...props });
        case "file-gif":
            return _jsx(FileGifIcon, { ...props });
        case "file-image":
            return _jsx(FileImageIcon, { ...props });
        case "file-jpg":
            return _jsx(FileJpgIcon, { ...props });
        case "file-lines":
            return _jsx(FileLinesIcon, { ...props });
        case "file-lock":
            return _jsx(FileLockIcon, { ...props });
        case "file-magnifying-glass":
            return _jsx(FileMagnifyingGlassIcon, { ...props });
        case "file-mp3":
            return _jsx(FileMp3Icon, { ...props });
        case "file-mp4":
            return _jsx(FileMp4Icon, { ...props });
        case "file-pdf":
            return _jsx(FilePdfIcon, { ...props });
        case "file-png":
            return _jsx(FilePngIcon, { ...props });
        case "file-ppt":
            return _jsx(FilePptIcon, { ...props });
        case "file-video":
            return _jsx(FileVideoIcon, { ...props });
        case "file-waveform":
            return _jsx(FileWaveformIcon, { ...props });
        case "file-xls":
            return _jsx(FileXlsIcon, { ...props });
        case "file-zip":
            return _jsx(FileZipIcon, { ...props });
        case "file":
            return _jsx(FileIcon, { ...props });
        case "files":
            return _jsx(FilesIcon, { ...props });
        case "filter-circle-xmark":
            return _jsx(FilterCircleXmarkIcon, { ...props });
        case "filter":
            return _jsx(FilterIcon, { ...props });
        case "flag-checkered":
            return _jsx(FlagCheckeredIcon, { ...props });
        case "flag-fill":
            return _jsx(FlagFillIcon, { ...props });
        case "flag-outline":
            return _jsx(FlagOutlineIcon, { ...props });
        case "flask":
            return _jsx(FlaskIcon, { ...props });
        case "flickr":
            return _jsx(FlickrIcon, { ...props });
        case "folder-open":
            return _jsx(FolderOpenIcon, { ...props });
        case "folder-plus":
            return _jsx(FolderPlusIcon, { ...props });
        case "folder":
            return _jsx(FolderIcon, { ...props });
        case "font":
            return _jsx(FontIcon, { ...props });
        case "forward-step":
            return _jsx(ForwardStepIcon, { ...props });
        case "forward":
            return _jsx(ForwardIcon, { ...props });
        case "foster-family":
            return _jsx(FosterFamilyIcon, { ...props });
        case "gauge-high":
            return _jsx(GaugeHighIcon, { ...props });
        case "gavel":
            return _jsx(GavelIcon, { ...props });
        case "gear":
            return _jsx(GearIcon, { ...props });
        case "gift-card":
            return _jsx(GiftCardIcon, { ...props });
        case "gift":
            return _jsx(GiftIcon, { ...props });
        case "globe":
            return _jsx(GlobeIcon, { ...props });
        case "google-drive":
            return _jsx(GoogleDriveIcon, { ...props });
        case "graduation-cap":
            return _jsx(GraduationCapIcon, { ...props });
        case "grid-2":
            return _jsx(Grid2Icon, { ...props });
        case "grid-list":
            return _jsx(GridListIcon, { ...props });
        case "grid":
            return _jsx(GridIcon, { ...props });
        case "grip-dots-vertical":
            return _jsx(GripDotsVerticalIcon, { ...props });
        case "group-in-hand":
            return _jsx(GroupInHandIcon, { ...props });
        case "hammer-brush":
            return _jsx(HammerBrushIcon, { ...props });
        case "hammer":
            return _jsx(HammerIcon, { ...props });
        case "hand-back-point-up":
            return _jsx(HandBackPointUpIcon, { ...props });
        case "hand-dots":
            return _jsx(HandDotsIcon, { ...props });
        case "hand-fist":
            return _jsx(HandFistIcon, { ...props });
        case "hand-holding-box":
            return _jsx(HandHoldingBoxIcon, { ...props });
        case "hand-holding-medical":
            return _jsx(HandHoldingMedicalIcon, { ...props });
        case "hand-holding-seedling":
            return _jsx(HandHoldingSeedlingIcon, { ...props });
        case "hand-wave":
            return _jsx(HandWaveIcon, { ...props });
        case "hand":
            return _jsx(HandIcon, { ...props });
        case "handcuffs":
            return _jsx(HandcuffsIcon, { ...props });
        case "hands-holding-circle":
            return _jsx(HandsHoldingCircleIcon, { ...props });
        case "hands-praying":
            return _jsx(HandsPrayingIcon, { ...props });
        case "handshake":
            return _jsx(HandshakeIcon, { ...props });
        case "hashtag":
            return _jsx(HashtagIcon, { ...props });
        case "head-side-brain":
            return _jsx(HeadSideBrainIcon, { ...props });
        case "head-side-medical":
            return _jsx(HeadSideMedicalIcon, { ...props });
        case "head-side-swallow":
            return _jsx(HeadSideSwallowIcon, { ...props });
        case "head-side-talking":
            return _jsx(HeadSideTalkingIcon, { ...props });
        case "head-side":
            return _jsx(HeadSideIcon, { ...props });
        case "headphones-simple":
            return _jsx(HeadphonesSimpleIcon, { ...props });
        case "heart-fill":
            return _jsx(HeartFillIcon, { ...props });
        case "heart-outline":
            return _jsx(HeartOutlineIcon, { ...props });
        case "heart-pulse-xmark":
            return _jsx(HeartPulseXmarkIcon, { ...props });
        case "heart-pulse":
            return _jsx(HeartPulseIcon, { ...props });
        case "highlight":
            return _jsx(HighlightIcon, { ...props });
        case "home":
            return _jsx(HomeIcon, { ...props });
        case "hospital":
            return _jsx(HospitalIcon, { ...props });
        case "hourglass-half":
            return _jsx(HourglassHalfIcon, { ...props });
        case "house-building":
            return _jsx(HouseBuildingIcon, { ...props });
        case "house-chimney-heart":
            return _jsx(HouseChimneyHeartIcon, { ...props });
        case "house-chimney-medical":
            return _jsx(HouseChimneyMedicalIcon, { ...props });
        case "house-chimney-user":
            return _jsx(HouseChimneyUserIcon, { ...props });
        case "house-chimney":
            return _jsx(HouseChimneyIcon, { ...props });
        case "house-circle-check":
            return _jsx(HouseCircleCheckIcon, { ...props });
        case "house-circle-xmark":
            return _jsx(HouseCircleXmarkIcon, { ...props });
        case "house-lock":
            return _jsx(HouseLockIcon, { ...props });
        case "house-medical":
            return _jsx(HouseMedicalIcon, { ...props });
        case "house-person-leave":
            return _jsx(HousePersonLeaveIcon, { ...props });
        case "icons":
            return _jsx(IconsIcon, { ...props });
        case "id-card":
            return _jsx(IdCardIcon, { ...props });
        case "image":
            return _jsx(ImageIcon, { ...props });
        case "inbox":
            return _jsx(InboxIcon, { ...props });
        case "increase-textsize":
            return _jsx(IncreaseTextsizeIcon, { ...props });
        case "indent":
            return _jsx(IndentIcon, { ...props });
        case "info":
            return _jsx(InfoIcon, { ...props });
        case "italic":
            return _jsx(ItalicIcon, { ...props });
        case "jo-logo":
            return _jsx(JoLogoIcon, { ...props });
        case "karify-archive-slash":
            return _jsx(KarifyArchiveSlashIcon, { ...props });
        case "karify-chevron-down-slash":
            return _jsx(KarifyChevronDownSlashIcon, { ...props });
        case "karify-folder":
            return _jsx(KarifyFolderIcon, { ...props });
        case "karify-healthspace":
            return _jsx(KarifyHealthspaceIcon, { ...props });
        case "karify-history":
            return _jsx(KarifyHistoryIcon, { ...props });
        case "karify-lock-slash":
            return _jsx(KarifyLockSlashIcon, { ...props });
        case "karify-logo":
            return _jsx(KarifyLogoIcon, { ...props });
        case "karify-minddistrict":
            return _jsx(KarifyMinddistrictIcon, { ...props });
        case "karify-puzzle-check":
            return _jsx(KarifyPuzzleCheckIcon, { ...props });
        case "karify-puzzle-pen":
            return _jsx(KarifyPuzzlePenIcon, { ...props });
        case "karify-roqua":
            return _jsx(KarifyRoquaIcon, { ...props });
        case "karify-shield-folder":
            return _jsx(KarifyShieldFolderIcon, { ...props });
        case "karify-shield-history":
            return _jsx(KarifyShieldHistoryIcon, { ...props });
        case "karify-shield":
            return _jsx(KarifyShieldIcon, { ...props });
        case "karify-shopping-bag":
            return _jsx(KarifyShoppingBagIcon, { ...props });
        case "karify-shopping-basket":
            return _jsx(KarifyShoppingBasketIcon, { ...props });
        case "karify-wing":
            return _jsx(KarifyWingIcon, { ...props });
        case "key":
            return _jsx(KeyIcon, { ...props });
        case "keyboard":
            return _jsx(KeyboardIcon, { ...props });
        case "layer-group":
            return _jsx(LayerGroupIcon, { ...props });
        case "light-emergency-on":
            return _jsx(LightEmergencyOnIcon, { ...props });
        case "lightbulb-on":
            return _jsx(LightbulbOnIcon, { ...props });
        case "link-simple":
            return _jsx(LinkSimpleIcon, { ...props });
        case "link-slash":
            return _jsx(LinkSlashIcon, { ...props });
        case "link":
            return _jsx(LinkIcon, { ...props });
        case "list-check":
            return _jsx(ListCheckIcon, { ...props });
        case "list-ol":
            return _jsx(ListOlIcon, { ...props });
        case "list-tree":
            return _jsx(ListTreeIcon, { ...props });
        case "list-ul":
            return _jsx(ListUlIcon, { ...props });
        case "location-crosshairs":
            return _jsx(LocationCrosshairsIcon, { ...props });
        case "location-dot-slash":
            return _jsx(LocationDotSlashIcon, { ...props });
        case "location-dot":
            return _jsx(LocationDotIcon, { ...props });
        case "lock-open":
            return _jsx(LockOpenIcon, { ...props });
        case "lock-register":
            return _jsx(LockRegisterIcon, { ...props });
        case "lock-user":
            return _jsx(LockUserIcon, { ...props });
        case "lock":
            return _jsx(LockIcon, { ...props });
        case "logging":
            return _jsx(LoggingIcon, { ...props });
        case "lungs":
            return _jsx(LungsIcon, { ...props });
        case "magnifying-glass-arrows-rotate":
            return _jsx(MagnifyingGlassArrowsRotateIcon, { ...props });
        case "magnifying-glass-minus":
            return _jsx(MagnifyingGlassMinusIcon, { ...props });
        case "magnifying-glass-plus":
            return _jsx(MagnifyingGlassPlusIcon, { ...props });
        case "magnifying-glass":
            return _jsx(MagnifyingGlassIcon, { ...props });
        case "map-location-dot":
            return _jsx(MapLocationDotIcon, { ...props });
        case "mars":
            return _jsx(MarsIcon, { ...props });
        case "megaphone":
            return _jsx(MegaphoneIcon, { ...props });
        case "message-arrow-down":
            return _jsx(MessageArrowDownIcon, { ...props });
        case "message-sms":
            return _jsx(MessageSmsIcon, { ...props });
        case "message":
            return _jsx(MessageIcon, { ...props });
        case "messages":
            return _jsx(MessagesIcon, { ...props });
        case "microphone-slash":
            return _jsx(MicrophoneSlashIcon, { ...props });
        case "microphone":
            return _jsx(MicrophoneIcon, { ...props });
        case "microsoft-onedrive":
            return _jsx(MicrosoftOnedriveIcon, { ...props });
        case "minus":
            return _jsx(MinusIcon, { ...props });
        case "mobile":
            return _jsx(MobileIcon, { ...props });
        case "money-bill-wave":
            return _jsx(MoneyBillWaveIcon, { ...props });
        case "money-check-pen":
            return _jsx(MoneyCheckPenIcon, { ...props });
        case "moon-cloud":
            return _jsx(MoonCloudIcon, { ...props });
        case "moon":
            return _jsx(MoonIcon, { ...props });
        case "mug-hot":
            return _jsx(MugHotIcon, { ...props });
        case "mug-saucer":
            return _jsx(MugSaucerIcon, { ...props });
        case "netherlands":
            return _jsx(NetherlandsIcon, { ...props });
        case "newspaper":
            return _jsx(NewspaperIcon, { ...props });
        case "note":
            return _jsx(NoteIcon, { ...props });
        case "objects-column":
            return _jsx(ObjectsColumnIcon, { ...props });
        case "outdent":
            return _jsx(OutdentIcon, { ...props });
        case "palette":
            return _jsx(PaletteIcon, { ...props });
        case "paper-plane":
            return _jsx(PaperPlaneIcon, { ...props });
        case "paperclip":
            return _jsx(PaperclipIcon, { ...props });
        case "paste-from-word":
            return _jsx(PasteFromWordIcon, { ...props });
        case "paste-text":
            return _jsx(PasteTextIcon, { ...props });
        case "paste":
            return _jsx(PasteIcon, { ...props });
        case "pause":
            return _jsx(PauseIcon, { ...props });
        case "pen-to-square":
            return _jsx(PenToSquareIcon, { ...props });
        case "pen":
            return _jsx(PenIcon, { ...props });
        case "people-arrows":
            return _jsx(PeopleArrowsIcon, { ...props });
        case "people-carry-box":
            return _jsx(PeopleCarryBoxIcon, { ...props });
        case "people-group":
            return _jsx(PeopleGroupIcon, { ...props });
        case "people-line":
            return _jsx(PeopleLineIcon, { ...props });
        case "person-chalkboard":
            return _jsx(PersonChalkboardIcon, { ...props });
        case "person-digging":
            return _jsx(PersonDiggingIcon, { ...props });
        case "person-falling-burst":
            return _jsx(PersonFallingBurstIcon, { ...props });
        case "person-falling":
            return _jsx(PersonFallingIcon, { ...props });
        case "person-helping":
            return _jsx(PersonHelpingIcon, { ...props });
        case "person-in-hand":
            return _jsx(PersonInHandIcon, { ...props });
        case "person-star":
            return _jsx(PersonStarIcon, { ...props });
        case "person-stars":
            return _jsx(PersonStarsIcon, { ...props });
        case "person-walking-with-cane":
            return _jsx(PersonWalkingWithCaneIcon, { ...props });
        case "person":
            return _jsx(PersonIcon, { ...props });
        case "phone-hangup":
            return _jsx(PhoneHangupIcon, { ...props });
        case "phone-missed":
            return _jsx(PhoneMissedIcon, { ...props });
        case "phone-plus":
            return _jsx(PhonePlusIcon, { ...props });
        case "phone":
            return _jsx(PhoneIcon, { ...props });
        case "photo-film":
            return _jsx(PhotoFilmIcon, { ...props });
        case "pills":
            return _jsx(PillsIcon, { ...props });
        case "plate-utensils":
            return _jsx(PlateUtensilsIcon, { ...props });
        case "play":
            return _jsx(PlayIcon, { ...props });
        case "plug":
            return _jsx(PlugIcon, { ...props });
        case "plus":
            return _jsx(PlusIcon, { ...props });
        case "prescription-bottle-medical":
            return _jsx(PrescriptionBottleMedicalIcon, { ...props });
        case "presentation-screen":
            return _jsx(PresentationScreenIcon, { ...props });
        case "print":
            return _jsx(PrintIcon, { ...props });
        case "puzzle-piece-simple":
            return _jsx(PuzzlePieceSimpleIcon, { ...props });
        case "qrcode":
            return _jsx(QrcodeIcon, { ...props });
        case "question":
            return _jsx(QuestionIcon, { ...props });
        case "quote-right":
            return _jsx(QuoteRightIcon, { ...props });
        case "receipt":
            return _jsx(ReceiptIcon, { ...props });
        case "reply":
            return _jsx(ReplyIcon, { ...props });
        case "right-left":
            return _jsx(RightLeftIcon, { ...props });
        case "rings-wedding":
            return _jsx(RingsWeddingIcon, { ...props });
        case "road":
            return _jsx(RoadIcon, { ...props });
        case "rocket-launch":
            return _jsx(RocketLaunchIcon, { ...props });
        case "room":
            return _jsx(RoomIcon, { ...props });
        case "rotate-exclamation":
            return _jsx(RotateExclamationIcon, { ...props });
        case "route":
            return _jsx(RouteIcon, { ...props });
        case "ruler":
            return _jsx(RulerIcon, { ...props });
        case "scale-balanced":
            return _jsx(ScaleBalancedIcon, { ...props });
        case "scissors":
            return _jsx(ScissorsIcon, { ...props });
        case "scroll":
            return _jsx(ScrollIcon, { ...props });
        case "sdb-logo":
            return _jsx(SdbLogoIcon, { ...props });
        case "share-nodes":
            return _jsx(ShareNodesIcon, { ...props });
        case "share":
            return _jsx(ShareIcon, { ...props });
        case "shield-check":
            return _jsx(ShieldCheckIcon, { ...props });
        case "shield-history":
            return _jsx(ShieldHistoryIcon, { ...props });
        case "shield-keyhole":
            return _jsx(ShieldKeyholeIcon, { ...props });
        case "shield-plus":
            return _jsx(ShieldPlusIcon, { ...props });
        case "shower":
            return _jsx(ShowerIcon, { ...props });
        case "shuffle":
            return _jsx(ShuffleIcon, { ...props });
        case "signature":
            return _jsx(SignatureIcon, { ...props });
        case "signpost":
            return _jsx(SignpostIcon, { ...props });
        case "sitemap":
            return _jsx(SitemapIcon, { ...props });
        case "skype":
            return _jsx(SkypeIcon, { ...props });
        case "sliders":
            return _jsx(SlidersIcon, { ...props });
        case "sort":
            return _jsx(SortIcon, { ...props });
        case "spinner-scale":
            return _jsx(SpinnerScaleIcon, { ...props });
        case "square-check":
            return _jsx(SquareCheckIcon, { ...props });
        case "square-facebook":
            return _jsx(SquareFacebookIcon, { ...props });
        case "square-parking":
            return _jsx(SquareParkingIcon, { ...props });
        case "stamp":
            return _jsx(StampIcon, { ...props });
        case "star-fill":
            return _jsx(StarFillIcon, { ...props });
        case "star-outline":
            return _jsx(StarOutlineIcon, { ...props });
        case "stethoscope":
            return _jsx(StethoscopeIcon, { ...props });
        case "stop":
            return _jsx(StopIcon, { ...props });
        case "stopwatch":
            return _jsx(StopwatchIcon, { ...props });
        case "strikethrough":
            return _jsx(StrikethroughIcon, { ...props });
        case "suitcase-medical":
            return _jsx(SuitcaseMedicalIcon, { ...props });
        case "sun-bright":
            return _jsx(SunBrightIcon, { ...props });
        case "sunglasses":
            return _jsx(SunglassesIcon, { ...props });
        case "syringe":
            return _jsx(SyringeIcon, { ...props });
        case "table-cells":
            return _jsx(TableCellsIcon, { ...props });
        case "table-columns":
            return _jsx(TableColumnsIcon, { ...props });
        case "table":
            return _jsx(TableIcon, { ...props });
        case "tag":
            return _jsx(TagIcon, { ...props });
        case "taxi-bus":
            return _jsx(TaxiBusIcon, { ...props });
        case "temperature-three-quarters":
            return _jsx(TemperatureThreeQuartersIcon, { ...props });
        case "text":
            return _jsx(TextIcon, { ...props });
        case "thought-bubble":
            return _jsx(ThoughtBubbleIcon, { ...props });
        case "thumbs-down-fill":
            return _jsx(ThumbsDownFillIcon, { ...props });
        case "thumbs-down-outline":
            return _jsx(ThumbsDownOutlineIcon, { ...props });
        case "thumbs-up-fill":
            return _jsx(ThumbsUpFillIcon, { ...props });
        case "thumbs-up-outline":
            return _jsx(ThumbsUpOutlineIcon, { ...props });
        case "thumbtack-fill":
            return _jsx(ThumbtackFillIcon, { ...props });
        case "thumbtack":
            return _jsx(ThumbtackIcon, { ...props });
        case "timeline-arrow":
            return _jsx(TimelineArrowIcon, { ...props });
        case "tombstone":
            return _jsx(TombstoneIcon, { ...props });
        case "tooth":
            return _jsx(ToothIcon, { ...props });
        case "toothbrush":
            return _jsx(ToothbrushIcon, { ...props });
        case "touch-id":
            return _jsx(TouchIdIcon, { ...props });
        case "train-tram":
            return _jsx(TrainTramIcon, { ...props });
        case "trash-can":
            return _jsx(TrashCanIcon, { ...props });
        case "tree-city":
            return _jsx(TreeCityIcon, { ...props });
        case "tree-palm":
            return _jsx(TreePalmIcon, { ...props });
        case "triangle-exclamation":
            return _jsx(TriangleExclamationIcon, { ...props });
        case "trophy":
            return _jsx(TrophyIcon, { ...props });
        case "truck-medical":
            return _jsx(TruckMedicalIcon, { ...props });
        case "umbrella-beach":
            return _jsx(UmbrellaBeachIcon, { ...props });
        case "umbrella":
            return _jsx(UmbrellaIcon, { ...props });
        case "underline":
            return _jsx(UnderlineIcon, { ...props });
        case "universal-access-dashed":
            return _jsx(UniversalAccessDashedIcon, { ...props });
        case "unlock-register":
            return _jsx(UnlockRegisterIcon, { ...props });
        case "unlock-user":
            return _jsx(UnlockUserIcon, { ...props });
        case "upload":
            return _jsx(UploadIcon, { ...props });
        case "user-check":
            return _jsx(UserCheckIcon, { ...props });
        case "user-clock":
            return _jsx(UserClockIcon, { ...props });
        case "user-crown":
            return _jsx(UserCrownIcon, { ...props });
        case "user-doctor":
            return _jsx(UserDoctorIcon, { ...props });
        case "user-group":
            return _jsx(UserGroupIcon, { ...props });
        case "user-hair":
            return _jsx(UserHairIcon, { ...props });
        case "user-invite":
            return _jsx(UserInviteIcon, { ...props });
        case "user-lock":
            return _jsx(UserLockIcon, { ...props });
        case "user-magnifying-glass":
            return _jsx(UserMagnifyingGlassIcon, { ...props });
        case "user-minus":
            return _jsx(UserMinusIcon, { ...props });
        case "user-pen":
            return _jsx(UserPenIcon, { ...props });
        case "user-plus":
            return _jsx(UserPlusIcon, { ...props });
        case "user-slash":
            return _jsx(UserSlashIcon, { ...props });
        case "user-xmark":
            return _jsx(UserXmarkIcon, { ...props });
        case "user":
            return _jsx(UserIcon, { ...props });
        case "users-medical":
            return _jsx(UsersMedicalIcon, { ...props });
        case "users":
            return _jsx(UsersIcon, { ...props });
        case "vacuum":
            return _jsx(VacuumIcon, { ...props });
        case "venus-mars":
            return _jsx(VenusMarsIcon, { ...props });
        case "venus":
            return _jsx(VenusIcon, { ...props });
        case "video-plus":
            return _jsx(VideoPlusIcon, { ...props });
        case "video-slash":
            return _jsx(VideoSlashIcon, { ...props });
        case "video":
            return _jsx(VideoIcon, { ...props });
        case "volume-xmark":
            return _jsx(VolumeXmarkIcon, { ...props });
        case "volume":
            return _jsx(VolumeIcon, { ...props });
        case "wand-magic-sparkles":
            return _jsx(WandMagicSparklesIcon, { ...props });
        case "whatsapp":
            return _jsx(WhatsappIcon, { ...props });
        case "wheat":
            return _jsx(WheatIcon, { ...props });
        case "wheelchair":
            return _jsx(WheelchairIcon, { ...props });
        case "wid":
            return _jsx(WidIcon, { ...props });
        case "xmark":
            return _jsx(XmarkIcon, { ...props });
        default:
            return null;
    }
};
export default IconAtomComponent;
